import { render, staticRenderFns } from "./StatisticsYearSection.vue?vue&type=template&id=6fc4a837&scoped=true&"
import script from "./StatisticsYearSection.vue?vue&type=script&lang=js&"
export * from "./StatisticsYearSection.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsYearSection.vue?vue&type=style&index=0&id=6fc4a837&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc4a837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VFlex,VIcon,VLayout})
